import React from "react"
import { Updater, Widget, any, fromJSX } from "widgets-for-react"
import { ProductApiResponseParsed, ProductForm, ProductFormState, ProductSaleDonation, getProductValidation } from "../productFormBlock.state"
import { FormControls } from "../../../../../../../Shared/Frontend/forms"
import { valutaDisplay } from "../utils"
import { capitalize } from "../../../../../../../Shared/Frontend/utils/capitalize"
import { t } from "i18next"

const ProductSaleDonationLayout = (form: ProductSaleDonation, rootState: ProductFormState, u: (_: Updater<ProductSaleDonation>) => void) => {
  const totalValue = form.price + (
    form.selectedIndex !== undefined
      ? +form.amounts[form.selectedIndex].amount
      : +form.manualAmount!
  )
  const donateValidation = getProductValidation(rootState, "wantToDonate")
  const donate2ndValidation = donateValidation.kind === "failed" ? { ...donateValidation, message: "" } : donateValidation
  const manualAmountValidation = getProductValidation(rootState, "manualAmount")

  const updater = {
    toggleDonate: (toggled: boolean) => {
      u(s0 => {
        return {
          ...s0,
          wantToDonate: toggled
        }
      })
    },
    setManualAmount: (amount: number) => {
      u(s0 => {
        return {
          ...s0,
          manualAmount: amount,
          selectedIndex: undefined
        }
      })
    },
    setPredefined: (index: number) => {
      u(s0 => {
        return {
          ...s0,
          manualAmount: undefined,
          selectedIndex: index
        }
      })
    }
  }

  return <>
    <p className='donation__seperator title--s'>Totaal {valutaDisplay(form.price)}</p>

    <p className='donation__seperator title--xs'>Wil je ReumaNederland nog meer steunen?</p>
    <FormControls.FormRadioInGroup
      key='donation-donate-sg-0'
      name='donation-donate-sg-0'
      disabled={false}
      required={false}
      errorMessage={donate2ndValidation.kind == 'failed' ? donate2ndValidation.message : undefined}
      items={['Ja, ik doneer'].map((item, index) => ({
        controlId: `donation-donate-sg-${index}`,
        label: capitalize(item),
        checked: form.wantToDonate === true,
        onChange: () => updater.toggleDonate(true)
      }))}
      boxed={true}
      direction='column'
    />

    {form.wantToDonate && <>
      <FormControls.FormRadioInGroup
        key='shop-amount-sg-2'
        name='shop-amount-sg-2'
        legend='Kies een bedrag'
        disabled={false}
        required={false}
        style='button'
        items={[
          ...form.amounts.map((amount, index) => {
            return {
              controlId: `donation-amount-sg-${index}`,
              label: capitalize(valutaDisplay(amount.amount)),
              checked: form.selectedIndex === index,
              onChange: () => updater.setPredefined(index)
            }
          }),
          {
            controlId: `donation-amount-sg-custom`,
            label: capitalize("anders"),
            checked: form.selectedIndex === undefined,
            onChange: () => updater.setManualAmount(form.amounts[form.selectedIndex!].amount)
          }
        ]}
      />

      {form.selectedIndex == undefined &&
        <div className='donation__amount' ref={ref => {
        const input = ref?.getElementsByTagName("input")[0]
        if (!input) return ref
        input.removeEventListener("keydown", blockCharacter)
        input.addEventListener("keydown", blockCharacter)
      }}>
          <FormControls.FormItemInGroup
            key='shop-amount-sg-3'
            controlId='shop-amount-sg-3'
            type='number'
            inputMode='numeric'
            label='Kies zelf een bedrag'
            disabled={false}
            required={false}
            value={form.manualAmount !== undefined ? String(form.manualAmount) : undefined}
            placeholder='Kies zelf een bedrag'
            onChange={amount => updater.setManualAmount(Number(amount))}
            errorMessage={manualAmountValidation.kind == 'failed' ? getManualAmountError(form) : undefined}
          />
        </div>
      }
      <br />
    </>}

    <FormControls.FormRadioInGroup
      key='donation-nodonate-sg-0'
      name='donation-nodonate-sg-0'
      disabled={false}
      required={false}
      errorMessage={donateValidation.kind == 'failed' ? donateValidation.message : undefined}
      items={['Nee, ik doneer niet'].map((item, index) => ({
        controlId: `donation-nodonate-sg-${index}`,
        label: capitalize(item),
        checked: form.wantToDonate === false,
        onChange: () => updater.toggleDonate(false)
      }))}
      boxed={true}
      direction='column'
    />

    {form.wantToDonate &&
      <p className='donation__seperator title--s'>Totaal {valutaDisplay(totalValue)}</p>
    }
  </>
}

export const productSaleDonationSegment = (form: ProductSaleDonation, rootState: ProductFormState): Widget<Updater<ProductApiResponseParsed>> => {
  return any<Updater<ProductSaleDonation>>([
    fromJSX<Updater<ProductSaleDonation>>(u => ProductSaleDonationLayout(form, rootState, u))
  ])
    .map<Updater<ProductForm>>(u => s0 => s0.kind === "product_sale_donation" ? u(s0) : s0)
    .map<Updater<ProductApiResponseParsed>>(u => s0 => ({ ...s0, productForm: u(s0.productForm) }))
}

const blockCharacter = (e: KeyboardEvent) => {
  if (e.key === "," || e.key === ".") {
    e.stopImmediatePropagation()
    e.stopPropagation()
    e.preventDefault()
  }
}

const getManualAmountError = (form: ProductSaleDonation) => {
  if (form.manualAmount == undefined) return undefined
  
  if (form.manualAmount < form.minimumAmount) return t("ProductForm:Error.MinAmount", { value: valutaDisplay(form.minimumAmount) })
  if (form.manualAmount > form.maximumAmount) return t("ProductForm:Error.MaxAmount", { value: valutaDisplay(form.maximumAmount) })
}
